<div>
  <form
    [formGroup]="approveForm"
    class="text-sm"
    (ngSubmit)="submitApproveForm()"
  >
    <div class="mb-5">
      <label
        for="domainName"
        [ngClass]="
          approveForm.controls['domainName'].touched
            ? approveForm.controls['domainName'].errors
              ? 'has-error'
              : 'has-success'
            : ''
        "
        >Domain Name</label
      >
      <div class="flex">
        <div
          class="flex items-center justify-center border border-[#e0e6ed] bg-[#eee] px-3 font-semibold dark:border-[#17263c] dark:bg-[#1b2e4b] ltr:rounded-l-md ltr:border-r-0 rtl:rounded-r-md rtl:border-l-0"
        >
          https://
        </div>
        <input
          id="domainName"
          formControlName="domainName"
          type="text"
          placeholder="tourisagent"
          (blur)="validateDomain()"
          class="form-input ltr:rounded-none rtl:rounded-none"
        />
        <div
          class="flex items-center justify-center border border-[#e0e6ed] bg-[#eee] px-3 font-semibold dark:border-[#17263c] dark:bg-[#1b2e4b] ltr:rounded-r-md ltr:border-l-0 rtl:rounded-l-md rtl:border-r-0"
        >
          .turistagent.com
        </div>
      </div>
      <small
        class="text-danger"
        *ngIf="
          approveForm.controls['domainName'].errors &&
          approveForm.controls['domainName'].touched
        "
      >
        {{ "please_provide_domainName" | translate }}
      </small>
      <small
        class="text-danger"
        *ngIf="approveForm.get('domainName')?.errors?.['invalidDomainName'] && approveForm.get('domainName')?.touched"
      >
        Only letters and dashes are allowed.
      </small>
      <small
        class="text-danger"
        *ngIf="approveForm.get('domainName')?.errors?.['domainTaken']  && approveForm.get('domainName')?.touched"
      >
        This domain is already taken.
      </small>
    </div>
    <div
      class="mb-5"
      [ngClass]="
        approveForm.controls['tier'].touched
          ? approveForm.controls['tier'].errors
            ? 'has-error'
            : 'has-success'
          : ''
      "
    >
      <label for="tier">Select Tier</label>
      <ng-select
        [items]="options$ | async"
        placeholder="Select Tier"
        [searchable]="false"
        [clearable]="false"
        class="custom-multiselect"
        bindLabel="title"
        bindValue="id"
        labelForId="tier"
        [formControlName]="'tier'"
        appendTo="body"
      >
      </ng-select>
      <small
        class="text-danger"
        *ngIf="
          approveForm.controls['tier'].errors &&
          approveForm.controls['tier'].touched
        "
      >
        {{ "please_provide_phone" | translate }}
      </small>
    </div>
    <div
      class="mt-8 flex items-center justify-end ltr:text-right rtl:text-left"
    >
      <button
        type="button"
        *ngIf="!isLoadingInstance"
        class="btn btn-outline-danger"
        (click)="closeModal()"
      >
        {{ "cancel" | translate }}
      </button>
      <button
        type="submit"
        *ngIf="!isLoadingInstance"
        class="btn btn-primary ltr:ml-4 rtl:mr-4"
      >
        {{ "submit" | translate }}
      </button>
      <button
        *ngIf="isLoadingInstance"
        type="button"
        class="btn btn-primary ltr:ml-4 rtl:mr-4"
      >
        <span
          class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"
        ></span
        >Loading
      </button>
    </div>
  </form>
</div>
